import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CommandesService } from 'src/app/services/commandes/commandes.service';
import { TransportorSocietyService } from 'src/app/services/transportor-society/transportor-society.service';

@Component({
  selector: 'app-valid-receipt-commandes',
  templateUrl: './valid-receipt-commandes.component.html',
  styleUrls: ['./valid-receipt-commandes.component.css'],
})
export class ValidReceiptCommandesComponent implements OnInit {
  @Output() result = new EventEmitter<any>();
  @Input() selectedCmds: any;

  offers: any;
  plateformList: any = [];
  transportorTypes: any = [];
  form?: FormGroup | any;

  collectorList: any = [];
  // transportorTypes: any[] = [
  //   { label: "complet", title: "Complet" },
  //   { label: "grouping", title: "Grouping" },
  //   { label: "combined", title: "Combined" }
  // ]

  constructor(
    private fb: FormBuilder,
    private activeModal: NgbActiveModal,
    private service: CommandesService,
    private transServices: TransportorSocietyService
  ) {}

  ngOnInit(): void {
    this._initForm();

    this.listCollectors();
  }

  _initForm() {
    const selectedTrans = this.selectedCmds[0]?.pickupedBy?._id;
    this.form = this.fb.group({
      selectedTransportor: this.fb.control(selectedTrans, {
        validators: [Validators.required],
      }),
      transportorType: this.fb.control('', {
        validators: [Validators.required],
      }),
      remorqueId: this.fb.control('', { validators: [Validators.required] }),
      plateform: this.fb.control('', { validators: [Validators.required] }),
      // offers: this.fb.array([])
    });

    /// get data contact selected transportor
    this.transServices
      .getContractSociety(selectedTrans)
      .then(async (res: any) => {
        // console.log("getContractSociety : ")
        // console.log(res)
        this.offers = res?.data?.offers;
        this.plateformList = this.offers
          .map((item) => item?.plateform)
          .filter((value, index, self) => self.indexOf(value) === index);
        this.transportorTypes = Array.from(
          new Set(
            this.offers
              .filter((o) => o?.type === 'transport')
              .reduce((acc: string[], o) => {
                const v = o?.labels;
                if (Array.isArray(v)) {
                  for (const t of v) if (t && t.trim()) acc.push(t);
                } else if (typeof v === 'string' && v.trim()) {
                  acc.push(v);
                }
                return acc;
              }, [] as string[])
          )
        );
      });
  }

  async listCollectors() {
    await this.transServices.allSocieties().then((res: any) => {
      if (res) {
        // console.log("leader res");
        // console.log(res);
        this.collectorList = res;
      }
    });
  }

  // === Getters utiles ===
  // get offersFA(): FormArray {
  //   return this.form.get('offers') as FormArray;
  // }

  // get totalPrice(): number {
  //   const ctrls = this.offersFA?.controls ?? [];
  //   return ctrls.reduce((sum, g: FormGroup) => {
  //     const raw = g.get('value')?.value;
  //     const n = typeof raw === 'string' ? parseFloat(raw) : Number(raw);
  //     return sum + (isFinite(n) ? n : 0);
  //   }, 0);
  // }

  // // Crée un FormGroup pour une offre
  // private newOffer(data?: Partial<any>) {
  //   return this.fb.group({
  //     label: [data?.label ?? '', [Validators.required, Validators.maxLength(100)]],
  //     // number (>= 0), autorise décimales
  //     value: [
  //       data?.value ?? null,
  //       [
  //         Validators.required,
  //         Validators.min(0)
  //       ]
  //     ]
  //   });
  // }

  // // Ajouter une offre vide (ou avec valeurs)
  // addOffer(data?: Partial<any>): void {
  //   this.offersFA.push(this.newOffer(data));
  // }

  // // Retirer une offre
  // removeOffer(index: number): void {
  //   // if (this.offersFA.length === 1) {
  //   //   return;
  //   // }
  //   this.offersFA.removeAt(index);
  // }

  // setOffers(offers: any): void {
  //   const arr = offers?.map(o => this.newOffer(o)) ?? [];
  //   this.form.setControl('offers', this.fb.array(arr));
  // }

  validate() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const data = this.form.value;
    // data.totalPrice = this.totalPrice
    data.cmds = this.selectedCmds.map((item) => item?._id);

    // data.totalVolume = this.selectedCmds.reduce(
    //   (acc, item) => acc + (Number(item.totalPalletVolume) || 0),
    //   0
    // );
    data.totalVolume = this.selectedCmds.reduce(
      (acc, item) => acc + (Number(item.totalVolume) || 0),
      0
    );
    data.totalWeight = this.selectedCmds.reduce(
      (acc, item) => acc + (Number(item.totalPoids) || 0),
      0
    );
    data.totalCost = this.selectedCmds.reduce(
      (acc, item) => acc + (Number(item.total_ca_cmd) || 0),
      0
    );

    // console.log(data)

    this.service.confirmPickups(data).then(async (res: any) => {
      // console.log("resssssssss : ")
      // console.log(res)
      if (res?.response) {
        this.result.emit(true);
        this.activeModal.dismiss();
      } else {
        alert(res?.msg);
      }
    });
  }

  closeModal() {
    this.result.emit(null);
    this.activeModal.dismiss();
  }
}
